(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define("noteworthycontent", ["react"], factory);
	else if(typeof exports === 'object')
		exports["noteworthycontent"] = factory(require("react"));
	else
		root["noteworthycontent"] = factory(root["React"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__2__) {
return 